import { FhsAxios } from "../../services/axios";
import securitiesTypes from "@/config/securitiesTypes";
import { hasItBeenLoaded } from "@/helpers/loading";
import user from "@/store/modules/auth.js";

export default {
  state: {
    stockList: null,
    securityType: 0,
    currentPage: 1,
    limit: "",
    reload: false
  },
  actions: {
    fetchStockList({ commit, getters, state }, searchQuery = "") {
      // Прерываем выполнение фукнции, если список уже загружен
      if (hasItBeenLoaded(state.stockList) && state.reload === false) {
        return;
      }

      // Сервер на данный момент воспинимает url с '/' в конце и url без '/' в конце, как разные
      searchQuery = searchQuery === "" ? "" : "/" + searchQuery;

      return new Promise((resolve, reject) => {
        FhsAxios.post("securities/filtered-list" + searchQuery, {
          conditions: {
            sec_type: getters.securityType
          },
          page: getters.currentPage,
          limit: getters.limit
        })
          .then(response => {
            commit("setStockList", response.data.result.data);
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    changeSecurityType({ commit }, selectedSecurityId) {
      commit("setSelectedSecurity", selectedSecurityId);
    },
    clearStockList({ commit }) {
      commit("unsetStockList");
    }
  },
  mutations: {
    setStockList(state, payload) {
      state.stockList = payload;
    },
    unsetStockList(state) {
      state.stockList = null;
    },
    setSelectedSecurity(state, selectedSecurityId) {
      state.securityType = selectedSecurityId;
      state.reload = true;
    }
  },
  getters: {
    stockList(state) {
      return !state.stockList ? [] : state.stockList;
    },
    isStockListLoading(state) {
      return state.stockList === null;
    },
    securityType(state) {
      return state.securityType;
    },
    currentPage(state) {
      return state.page;
    },
    limit(state) {
      return state.limit;
    },
    securitiesTypes(state) {
      return securitiesTypes.map(securityType => {
        // Определяем выбранный тип ценных бумаг и добавляем метку для данного типа
        if (String(securityType.value) === String(state.securityType)) {
          return {
            value: securityType.value,
            text: securityType.text,
            selected: true
          };
        } else {
          return securityType;
        }
      });
    }
  }
};
